import { useTranslation } from "react-i18next";
import { useUID } from "../../context/UIDContext";
import { useAmplitude } from "../../context/AmplitudeContext";
import "./styles.css";

export const ProductCards = ({ products, layout }) => {
  const { t } = useTranslation("recommendation");
  const { uid } = useUID();
  const trackEvent = useAmplitude();

  // track product click event
  const trackProductClick = (productTitle, productUrl) => {
    trackEvent(
      "webapp_user_clicked_product",
      uid,
      "",
      "",
      productTitle,
      productUrl,
    );
  };

  return (
    <div className={`product-cards_${layout}`}>
      {products.map((product, index) => (
        <div
          key={index}
          className={`product-card_${layout}`}
          onClick={() => {
            trackProductClick(product.title, product.url);
            if (product.url) {
              const newWindow = window.open(
                product.url,
                "_blank",
                "noopener,noreferrer",
              );
              if (newWindow) newWindow.opener = null;
            }
          }}
        >
          <div className={`product-img-container_${layout}`}>
            <img
              src={
                product.image
                  ? `data:image/png;base64, ${product.image}`
                  : "placeholder.png"
              }
              alt={product.title}
              className={`${!product.image ? "placeholder" : `product-img_${layout}`}`}
            />
          </div>
          <h4 className="product-brand">
            {product.brand === "" ? "\u00A0" : product.brand}
          </h4>
          {product.title && <h4 className="product-title">{product.title}</h4>}

          {/* product details */}
          {/* {layout !== "grid" && product.detail && (
              <p className="product-details">{product.detail}</p>
            )} */}

          <div className="product-assets">
            {product.url && (
              <h4 className="product-link">{t("product-details")}</h4>
            )}

            {product.price && (
              <h4 className="product-price">{product.price}</h4>
            )}

            {/* product size */}
            {/* {product.size && <h4 className="product-price">{product.size}</h4>} */}
          </div>
        </div>
      ))}
    </div>
  );
};
